import { Boxes } from 'lucide-react';
import GenericModulePage from './GenericModulePage';
import { storeAPI } from '../lib/api';

const config = {
  title: 'Central Store',
  subtitle: 'Consumables, surgical supplies, and central inventory.',
  icon: Boxes,
  permPrefix: 'store',
  testId: 'store',
  idLabel: 'Item',
  fields: [
    { key: 'item_name', label: 'Item Name', type: 'text', required: true, listColumn: true },
    { key: 'category', label: 'Category', type: 'select', options: ['Surgical', 'Consumable', 'Stationery', 'Linen', 'Equipment', 'Other'], listColumn: true },
    { key: 'unit', label: 'Unit', type: 'text', placeholder: 'pcs / box / pkt', listColumn: true },
    { key: 'quantity', label: 'Quantity in Stock', type: 'number', required: true, listColumn: true },
    { key: 'reorder_level', label: 'Reorder Level', type: 'number' },
    { key: 'unit_price', label: 'Unit Price (₹)', type: 'number', listColumn: true },
    { key: 'supplier', label: 'Supplier', type: 'text' },
    { key: 'last_received_on', label: 'Last Received On', type: 'date' },
    { key: 'remarks', label: 'Remarks', type: 'textarea', fullWidth: true },
  ],
};

export default function StorePage() { return <GenericModulePage config={config} apiClient={storeAPI} />; }
